import React, { useState, useRef } from 'react';
import pt from 'prop-types';
import * as styles from './radiobutton.module.scss';
import { combine } from '/src/helpers/styles';
import Text from '../text';

const Radiobutton = ({
  label,
  checked,
  defaultChecked,
  onClick,
  disabled,
  className,
  isLink,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);
  // Using ref to handle hover state as CSS is more reliable than mouseenter and mouseleave events
  const labelRef = useRef();

  const inputProps = {
    type: 'radio',
    ...(checked !== undefined && { checked }),
    ...(defaultChecked !== undefined && { defaultChecked }),
    ...(onClick !== undefined && { onChange: onClick }),
    disabled,
    ...props,
  };

  const Input = ({ children }) => {
    if (isLink) {
      return (
        <div className={combine(styles.link, disabled && styles.disabled)}>
          {children}
        </div>
      );
    }

    return children;
  };

  return (
    <Input>
      <label
        className={combine(
          styles.checkbox,
          disabled && styles.disabled,
          className
        )}
        ref={labelRef}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Text
          as="span"
          type="metanavi"
          variant={
            labelRef.current && labelRef.current.matches(':hover') ? 'bold' : ''
          }
        >
          {label}
        </Text>
        <input {...inputProps} />
        <span className={styles.checkmark}></span>
      </label>
    </Input>
  );
};

Radiobutton.propTypes = {
  label: pt.string.isRequired,
  onClick: pt.func.isRequired,
  className: pt.string,
  checked: pt.bool,
  defaultChecked: pt.bool,
  isLink: pt.bool,
  disabled: pt.bool,
};
Radiobutton.defaultProps = {
  disabled: false,
  className: '',
};

export default Radiobutton;
